import { useParams } from "react-router-dom";
import SessionsHome from "@/components/recstudio/SessionsHome";
import Workspace from "@/components/recstudio/Workspace";

/** ELPM Advanced Studio — Smart Recording: `/create/studio` (sessions + setup) and `/create/studio/:sessionId`. */
export default function RecStudioPage() {
  const { sessionId } = useParams();
  return sessionId ? <Workspace key={sessionId} sessionId={sessionId} /> : <SessionsHome />;
}
